import { useMap } from 'react-leaflet';
import { useEffect, useRef, ReactNode } from 'react';
import ReactDOM from 'react-dom';
// importamos *a classe* Control e o DomUtil que são valores, além do tipo ControlPosition
import { Control, DomUtil, type ControlPosition } from 'leaflet';

interface Props {
    position?: ControlPosition;
    children: ReactNode;
}

export default function LeafletControl({
    position = 'topright',
    children
}: Props) {
    const map = useMap();
    // container é um DIV puro que vai virar o "pane" do nosso controle
    const container = useRef<HTMLDivElement>(DomUtil.create('div'));

    useEffect(() => {
        // aqui usamos a classe diretamente
        const ctl = new Control({ position });
        ctl.onAdd = () => container.current;
        ctl.addTo(map);
        return () => void ctl.remove();
    }, [map, position]);

    // portaliza o React dentro do container do Leaflet
    return ReactDOM.createPortal(children, container.current);
}
